module.exports = __webpack_public_path__ + "static/img/dinners_9.4031661.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menus/dinners/dinners_9.jpg
// module id = hbZ4
// module chunks = 1